import { Accordion, AccordionDetails, AccordionSummary, createStyles, makeStyles, Paper, SvgIconTypeMap, Theme, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        sectionCard: {
            padding: '0px',
            display: 'flex',
            flexDirection: 'column' as const,
            gap: theme.spacing(2),
        },
        sectionHead: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '10px',
        },
        sectionIcon: {
            width: '32px',
            height: '32px',
            borderRadius: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            fontSize: '16px',
        },
        sectionTitle: {
            fontSize: '12px',
            letterSpacing: '0.07em',
            textTransform: 'uppercase' as const,
            fontWeight: 600,
            marginBottom: '3px',
        },
        sectionDesc: {
            fontSize: '13px',
            color: theme.palette.text.secondary,
            lineHeight: 1.5,
        },
        accordionDetails: {
            flexDirection: 'column' as const,
        },
    }),
);

interface FormSectionCardProps extends React.PropsWithChildren<{}> {
    title: string;
    description?: string;
    color?: string;
    bgColor?: string;
    icon?: OverridableComponent<SvgIconTypeMap>;
    defaultExpanded?: boolean;
    useDefaultTitleColor?: boolean;
}

export function FormSectionAccordionCard(props: FormSectionCardProps) {
    const classes = useStyles();

    return (
        <Accordion
            component={Paper}
            defaultExpanded={props.defaultExpanded ?? true}
        >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <div className={classes.sectionHead}>
                    {props.icon ? (
                        <div
                            className={classes.sectionIcon}
                            style={{
                                backgroundColor: props.bgColor ?? '#e0e0e0',
                                color: props.color ?? '#000',
                            }}
                        >
                            <props.icon fontSize="small" />
                        </div>
                    ) : null}
                    <div>
                        <Typography
                            className={classes.sectionTitle}
                            style={props.useDefaultTitleColor ? undefined : { color: props.color ?? '#000' }}
                        >
                            {props.title}
                        </Typography>
                        {props.description && (
                            <Typography className={classes.sectionDesc}>
                                {props.description}
                            </Typography>
                        )}
                    </div>
                </div>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
                {props.children}
            </AccordionDetails>
        </Accordion>
    );
}
